const paymentMethodFormEnum = Object.freeze({
  PAY_2C2P_CARD_FORM: '2C2P',
});

export default paymentMethodFormEnum;
